<template>
  <div>
    <WorkshopHeroSection
      :workshopDetails="details"
      style="background: #475CC7;"
    />

    <div
      id="webinar-section-2"
      style="box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.12);"
    >
      <v-container>
        <WorkshopSpeaker
          :speaker_details="sessionDetails.speaker_details"
          :status="sessionDetails.status"
          :speaker_designation="sessionDetails.speaker_designation"
        />
      </v-container>
    </div>
    <div style="box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.12);">
      <v-container>
        <WorkshopTakeAway :takeAway="sessionDetails.take_away" />
      </v-container>
    </div>
    <div style="box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.12);">
      <v-container>
        <WhyEblityWorkshops />
      </v-container>
    </div>
    <div style="box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.12);">
      <v-container>
        <WorkshopFAQs />
      </v-container>
    </div>
    <div>
      <v-container>
        <WorkshopTestimonials />
      </v-container>
    </div>
    <v-row id="webinar-section-5" class="ma-0 mt-12" style="background:#fff">
      <v-container>
        <WorkshopGroupsSkillsTags
          :ageGroup="sessionDetails.ageGroup"
          :skills="sessionDetails.skills"
          :tags="sessionDetails.tags"
        />
      </v-container>
    </v-row>
  </div>
</template>

<script>
  import helper from "@/helper";

  import WorkshopHeroSection from "./components/HeroSection/HeroSection.vue";
  import WorkshopGroupsSkillsTags from "./components/WorkshopGroupsSkillsTags.vue";
  import WorkshopSpeaker from "./components/WorkshopSpeaker.vue";
  import WorkshopTakeAway from "./components/WorkshopTakeAway.vue";
  import WhyEblityWorkshops from "./components/WhyEblityWorkshops.vue";
  import WorkshopFAQs from "./components/WorkshopFAQs.vue";
  import WorkshopTestimonials from "./components/WorkshopTestimonial.vue";

  import AmplitudeHelper from "../../../amplitude";
  import store from "../../../store";
  import ShareHelper from "../../../helper/share";
  import { ROUTER_URL } from "@/constants/urls";
  
  export default {
    name: "WorkshopDetails",
    props: ["details"],
    components: {
      WorkshopHeroSection,
      WorkshopTestimonials,
      WorkshopFAQs,
      WhyEblityWorkshops,
      WorkshopTakeAway,
      WorkshopSpeaker,
      WorkshopGroupsSkillsTags,
    },
    data() {
      return {
        display: false,
        whatsappUrl: "",
      };
    },
    created() {
      AmplitudeHelper.registerAmplitudeEvent(
        "view workshop detail page",
        this.getEventProperties({})
      );
      this.$store.state.pageLocation = "workshop";
    },
    computed: {
      sessionDetails() {
        var session_list = [];

        this.details.session_list.forEach((element) => {
          session_list.push({
            title: element.session_title,
            dates: helper.formatDate(element.date) + " " + element.time,
            abstract: element.session_abstract,
            thumbnailPath: element.thumbnail_path,
          });
        });

        return {
          id: this.details.id,
          headerImage: this.details.thumbnail_path,
          dateToFrom: this.getFormattedDate(),
          title: this.details.title,
          subTitle: this.details.sub_heading,
          take_away: this.details.take_aways,
          type: this.details.type,
          speaker_details: {
            educatorName: this.details.conductor_details.user_details
              ? this.details.conductor_details.user_details.name
              : "",
            educatorImage: this.details.speaker_image
              ? this.details.speaker_image
              : "",
            educatorBio: this.details.speaker_bio
              ? this.details.speaker_bio
              : "",
          },
          skills: this.details.skills,
          ageGroup: this.details.age_groups,
          tags: this.details.tags,
          price: this.details.amount,
          is_free: this.details.is_free,
          hostedBy: this.details.conductor_details.user_details
            ? this.details.conductor_details.user_details.name
            : "",
          sessionsList: session_list,
          offerAndPricing: {
            allSessions: {
              title: "All 3 Session",
              price: this.details.amount,
              abstract: [
                "Why communication is important for a child with DS?",
                "How to reduce the gap for communication development milestones?",
                "Why early intervention is critical?",
                "Strategies",
                "Resources",
              ],
            },
            individualSession: {
              title: "Individual Session",
              price: this.details.individual_amount,
              abstract: [
                "Why communication is important for a child with DS?",
                "Why communication is important for a child with DS?",
                "How to reduce the gap for communication development milestones?",
              ],
            },
            sessionList: session_list,
          },
          status: this.details.status, //On Demand, Scheduled, Published
          date: helper.formatDate(this.details.start_date_time),
          day: helper.getDay(this.details.start_date_time),
          time:
            helper.formatTime(new Date(this.details.start_date_time)) +
            ", " +
            helper.getTimezoneName(new Date(this.details.start_date_time)),
          sessions: this.details.session_list,
          is_bought: this.details.is_bought,
          is_requested: this.details.is_requested,
          speaker_designation: this.details.speaker_designation
            ? this.details.speaker_designation
            : "",
        };
      },
    },
    watch: {},
    methods: {
      getFormattedDate() {
        return (
          helper.formatDate(this.details.start_date_time) +
          " - " +
          helper.formatDate(this.details.end_date_time)
        );
      },
      emailShare() {
        AmplitudeHelper.registerAmplitudeEvent(
          "share workshop",
          this.getEventProperties({
            "share platform": "Email",
          })
        );
        window.location =
          "mailto:?body=" +
          this.makePublicLink() +
          "&subject=I thought this link might interest you.";
      },
      makePublicLink() {
        let props = this.$router.resolve({
          name: ROUTER_URL.publicSession.children.sessionDetails.name,
          params: { id: this.sessionDetails.id },
        });
        return window.location.origin + props.href;
      },
      copyLink() {
        var text = window.location.href;
        let props = this.$router.resolve({
          name: ROUTER_URL.publicSession.children.sessionDetails.name,
          params: { id: this.sessionDetails.id },
        });
        console.log(props);
        text = window.location.origin + props.href;

        // text = text.replace("app", "parent");

        var dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        store.dispatch("snackBar/showToast", {
          message: "Share link copied.",
          color: "S",
        });
      },
      facebookShare() {
        AmplitudeHelper.registerAmplitudeEvent(
          "share workshop",
          this.getEventProperties({
            "share platform": "Facebook",
          })
        );

        ShareHelper.onFacebook({
          link: this.makePublicLink(),
          text: this.getShareText(),
        });
      },
      twitterShare() {
        AmplitudeHelper.registerAmplitudeEvent(
          "share workshop",
          this.getEventProperties({
            "share platform": "Twitter",
          })
        );

        ShareHelper.onTwitter({
          url: this.makePublicLink() + "\n\n",
          text: this.getShareText(),
          tag: "Workshop",
        });
      },
      getShareText() {
        var text = "";
        if (this.sessionDetails.status == "Published") {
          text =
            "Check out the latest workshop by Eblity - Click on the link below to know more.\n";
        } else if (this.sessionDetails.status == "On-Demand") {
          text =
            "Have you registered for this workshop by Eblity? Think this would be useful for you.\n";
        } else {
          text =
            "I recommend you to watch this workshop. It has some amazing things to learn from.\n";
        }
        return text;
      },
      getEventProperties(properties) {
        properties["workshop name"] = this.details.title;
        properties["tags"] = [
          ...new Set(this.details.tags.map((element) => element.name)),
        ];
        properties["skills"] = [
          ...new Set(this.details.skills.map((element) => element.name)),
        ];
        properties["age group"] = [
          ...new Set(this.details.age_groups.map((element) => element.name)),
        ];
        return properties;
      },
    },
    mounted() {
      this.whatsappUrl =
        "whatsapp://send?text=" +
        this.getShareText() +
        "%0a" +
        this.makePublicLink();
      AmplitudeHelper.registerEvent("Workshop - View", this.details);
    },
  };
</script>

<style scoped>
  .groups-skills-tags {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: #333333;
  }
  .why-webinar-title {
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
  }
  .why-webinar-info {
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    text-align: center;

    color: rgba(0, 0, 0, 0.59);
  }
  .speaker-details-background {
    /* background: radial-gradient(110% 50% at top, transparent 50%, lightblue 51%); */
    background: #ffffff;
    border-top-left-radius: 45%;
    border-top-right-radius: 45%;
  }
  .speaker-details-background-mobile {
    /* background: radial-gradient(110% 50% at top, transparent 50%, lightblue 51%); */
    background: #ffffff;
    border-top-left-radius: 0%;
    border-top-right-radius: 0%;
  }
</style>
